<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M5.25,12c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S6.904,12,5.25,12z M5.25,7.5c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S6.077,7.5,5.25,7.5z"/>
	<path d="M12,12c-1.654,0-3-1.346-3-3s1.346-3,3-3c1.654,0,3,1.346,3,3S13.654,12,12,12z M12,7.5c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S12.827,7.5,12,7.5z"/>
	<path d="M12,24c-1.654,0-3-1.346-3-3s1.346-3,3-3c1.654,0,3,1.346,3,3S13.654,24,12,24z M12,19.5c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S12.827,19.5,12,19.5z"/>
	<path d="M8.25,18c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S9.904,18,8.25,18z M8.25,13.5c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S9.077,13.5,8.25,13.5z"/>
	<path d="M15.75,18c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S17.404,18,15.75,18z M15.75,13.5c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S16.577,13.5,15.75,13.5z"/>
	<path d="M18.75,12c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S20.404,12,18.75,12z M18.75,7.5c-0.827,0-1.5,0.673-1.5,1.5
		s0.673,1.5,1.5,1.5s1.5-0.673,1.5-1.5S19.577,7.5,18.75,7.5z"/>
	<path d="M11.839,4.509c-0.363,0-0.674-0.26-0.738-0.618c-0.148-0.826,0.015-1.677,0.441-2.391H9.75C9.336,1.5,9,1.164,9,0.75
		S9.336,0,9.75,0h6c0.414,0,0.75,0.336,0.75,0.75S16.164,1.5,15.75,1.5h-2.087c-0.785,0.382-1.24,1.264-1.085,2.127
		c0.073,0.407-0.199,0.798-0.606,0.871C11.928,4.505,11.883,4.509,11.839,4.509z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'fruit-grapes',
    },
    name: {
      type: String,
      required: false,
      default: 'FruitGrapes',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>